import { render } from "./App.vue?vue&type=template&id=10277a04&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10277a04&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/maider/maider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10277a04"]])

export default __exports__